import React from 'react';
import BankingHero from './BankingHero';
import BankingIntegrationImg from "../../../assets/home_section3_2.png";

const BankingIntegration = () => {
  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css"
      />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <section className="flex justify-center items-center px-10 py-16 bg-gray-50 min-h-screen max-md:flex-col max-md:px-5 max-md:py-10">
        <div className="flex gap-16 items-center w-full max-w-[1200px] max-md:flex-col max-md:gap-10">
          <div className="flex-1 max-md:w-full">
            <img
              src={BankingIntegrationImg}
              alt="Banking Technology Integration"
              className="w-full h-auto rounded-[16px] shadow-[0_10px_40px_rgba(0,0,0,0.1)]"
            />
          </div>
          <BankingHero />
        </div>
      </section>
    </>
  );
};

export default BankingIntegration;
